import {FeatureServiceItem} from "./feature-service-item";

export class FeatureServices {
    constructor() {
        this.DOM = {main: document.querySelector('.js-featureServices')};
        if (!this.DOM.main) return;

        this.onAcitve = 0;
        this.serviceItems = [];
        this.init();
    }

    init() {
        this.DOM.main.querySelectorAll('.js-serviceItem_wrap').forEach((el, index) => {
            this.serviceItems.push(new FeatureServiceItem({
                el,
                onHover: this.onHover.bind(this),
                onLeave: this.onLeave.bind(this),
                index
            }));
        });
    }

    onHover(index) {
        this.serviceItems.forEach(item => {
            if (index !== item.index) {
                item.out();
            }
        });
    }

    onLeave(index) {
        this.serviceItems.forEach(item => {
            item.clear();
        });
    }
}